export default __webpack_public_path__ + "static/media/exchange.ee6f98dd.svg";